import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputMui } from '../../../../../../../../components';
import { InputSliderDialog } from '../../../../../../../../components/input-slider-dialog';
import { KeyedFloatValidation } from '../../../../../../../../data-access/gql-types/graphql';
import { useMeterConfigurationContext } from '../../context';
import { useMeterConfigErrorMessage } from '../../hooks/use-error-message';
import { SourceThresholdComponentType } from '../../types';
import { sourceThresholdComponent } from '../../utils';

type SourceThresholdComponentProps = {
  selectedSource: string;
  thresholdUnit: string;
  propertyName: 'minValue' | 'maxValue';
  validation?: KeyedFloatValidation;
};

export const SourceThresholdComponent: React.FC<SourceThresholdComponentProps> = ({
  selectedSource,
  thresholdUnit,
  propertyName,
  validation,
}) => {
  const { t } = useTranslation('channel-details');
  const { t: tc } = useTranslation('common');
  const { activeRuleIndex, form } = useMeterConfigurationContext();
  const { getErrorMessage } = useMeterConfigErrorMessage();
  const label = t('meterConfiguration.thresholdEvent.threshold');

  return (
    <Controller
      name={`rules.${activeRuleIndex}.${propertyName}`}
      control={form.control}
      rules={{ required: tc('isRequired') as string }}
      render={({ field, fieldState: { error } }) => {
        const errorMessage = getErrorMessage(activeRuleIndex, propertyName, error);

        return sourceThresholdComponent[selectedSource] === SourceThresholdComponentType.Slider ? (
          <InputSliderDialog
            value={field.value}
            handleSaveValue={(val) => field.onChange(val)}
            unit={thresholdUnit}
            min={validation?.validation.min}
            max={validation?.validation.max}
            step={validation?.validation.step}
            dialogTitle={label}
            inputLabel={label}
            reverse
            disabled={!selectedSource}
            {...(errorMessage && { errorMessage })}
          />
        ) : (
          <InputMui
            value={String(field.value || '')}
            label={`${label} (${thresholdUnit})`}
            type="number"
            min={validation?.validation.min}
            max={validation?.validation.max}
            step={validation?.validation.step}
            disabled={!selectedSource}
            reverse
            onChange={(e) => field.onChange(e.target.value ? Number(e.target.value) : '')}
            {...(errorMessage && { errorMessage })}
          />
        );
      }}
    />
  );
};
